import { BaseObject } from "../core/BaseObject";

export class EmployeeCategory extends BaseObject {
    employeeCategoryId: number;
    name: string;
}